import * as React from 'react';
import { PreviewMode } from './preview-context';

export const SuggestionPreviewWrapper = (props: any) => {
  return (
    <PreviewMode.Consumer>
      {(value) => (value.isPreview ? null : props.children)}
    </PreviewMode.Consumer>
  );
};
